<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- general tab -->
    <b-tab active>
      <!-- title -->
      <template #title>
        <feather-icon icon="UserIcon" size="18" class="mr-50" />
        <span class="font-weight-bold text-capitalize">
          {{ $t("user_profile.general") }}</span
        >
      </template>

      <account-setting-general />
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="LockIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{ $t("user_profile.change_password") }}</span>
      </template>

      <account-setting-password />
    </b-tab>
    <!--/ change password tab -->

    <!-- notification -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="BellIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{ $t("user_profile.notifications.title") }}</span>
      </template>

      <account-setting-notification
        :notification-data="options.notification"
      />
    </b-tab>

    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="MailIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{ $t("auth_two_factor.title") }}</span>
      </template>
      <account-setting-auth-two-factor />
    </b-tab>

    <b-tab v-if="$can('create_qr_app', 'AccountSettings')">
      <!-- title -->
      <template #title>
        <feather-icon icon="SmartphoneIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{ $t("account_settings.mobile_app.title") }}</span>
      </template>
      <account-setting-mobile-app />
    </b-tab>

    <b-tab v-if="$can('read', 'AppColors')">
      <!-- app color -->
      <template #title>
        <svg class="brushIcon2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
          <g fill="none">
            <path d="M5.75 2a.75.75 0 0 0-.75.75v11.5a2.25 2.25 0 0 0 2.25 2.25H9.5v3a2.5 2.5 0 1 0 5 0v-3h2.25A2.25 2.25 0 0 0 19 14.25V2.75a.75.75 0 0 0-.75-.75H5.75zm.75 9V3.5h6v1.752a.75.75 0 1 0 1.5 0V3.5h1v2.751a.75.75 0 1 0 1.5 0V3.5h1V11h-11zm0 3.25V12.5h11v1.75a.75.75 0 0 1-.75.75h-3a.75.75 0 0 0-.75.75v3.75a1 1 0 0 1-2 0v-3.75a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 1-.75-.75z" fill="currentColor">
            </path>
          </g>
        </svg>
        <span class="font-weight-bold">{{ $t("account_settings.appColors.title") }}</span>
      </template>
      <AccountSettingAppColors />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from "bootstrap-vue";
import AccountSettingGeneral from "./AccountSettingGeneral.vue";
import AccountSettingPassword from "./AccountSettingPassword.vue";
import AccountSettingInformation from "./AccountSettingInformation.vue";
import AccountSettingSocial from "./AccountSettingSocial.vue";
import AccountSettingNotification from "./AccountSettingNotification.vue";
import AccountSettingAuthTwoFactor from "./AccountSettingAuthTwoFactor.vue";
import AccountSettingMobileApp from './AccountSettingMobileApp.vue'
import AccountSettingAppColors from "./AccountSettingAppColors.vue";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingAuthTwoFactor,
    AccountSettingInformation,
    AccountSettingSocial,
    AccountSettingNotification,
    AccountSettingMobileApp,
    AccountSettingAppColors
  },
  data() {
    return {
      options: {},
      user: {},
    };
  }
};
</script>
<style scoped>
.brushIcon2 {
  width: 19px;
  height: 19px;
}
</style>
